import { ComponentType, lazy as reactLazy, LazyExoticComponent } from 'react';
import { chunkLoadTracker } from './chunkLoadTracker';

/**
 * Drop-in replacement for `React.lazy` that reports the underlying dynamic
 * import to the {@link chunkLoadTracker}, so the global route progress bar
 * reflects the load. `React.lazy` calls the factory only once (and caches the
 * module), so already-loaded routes signal nothing and navigate instantly.
 *
 * Route files import this as `lazy` from `@components/common/routeLoading`.
 */
// Mirror React.lazy's own `ComponentType<any>` constraint so any route
// component (with any props shape) is accepted.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithProgress = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> =>
  reactLazy(() => {
    chunkLoadTracker.begin();
    return factory().finally(() => chunkLoadTracker.end());
  });
